import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

export interface SelectOption {
  readonly value: string;
  readonly label: string;
}

@Component({
  selector: 'lib-bo-auth-select',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './bo-auth-select.component.html',
  styleUrls: ['./bo-auth-select.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BoAuthSelectComponent {
  readonly inputId = input.required<string>();
  readonly label = input.required<string>();
  readonly options = input.required<readonly SelectOption[]>();
  readonly control = input.required<FormControl>();
  readonly placeholder = input('');
  readonly ariaLabel = input('');
  readonly disabled = input(false);
}
